import { Button, Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import { LazyLoadedSignature } from 'src/core/common/components/Signature/LazyLoadedSignature';
import { logger } from 'src/utils/datadog-log-wrapper';

import { AffidavitSignatureLoader } from './AffidavitSignatureLoader';

import './AffidavitSignatureModal.css';

type Props = {
  isLoading: boolean;
  signatureImageUrl: string;
  onBack: () => void;
  onSigned: () => void;
  onFinish: () => void;
};

export const AffidavitSignatureModal = ({
  isLoading,
  signatureImageUrl,
  onBack,
  onSigned,
  onFinish,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen
      className="AffidavitSignatureModal w-[900px]"
      iconName="receipt-question"
      title={t('payments.affidavitModal.signatureModal.title')}
      actions={[
        <Button
          key="back"
          text={t('payments.affidavitModal.signatureModal.backButton')}
          isDisabled={isLoading}
          onClick={onBack}
        />,
      ]}
    >
      <div className="AffidavitSignatureModal__signature" data-mask>
        {isLoading && <AffidavitSignatureLoader />}
        {signatureImageUrl && (
          <LazyLoadedSignature
            signatureURL={signatureImageUrl}
            onSignSuccess={async () => {
              logger.info('DropboxSign signed', {
                href: window.location.href,
                team: 'travel-and-expenses',
                scope: 'affidavit-signature',
              });
              await onSigned();
              onFinish();
            }}
            onSignError={(error) => {
              logger.warn('DropboxSign error', {
                href: window.location.href,
                team: 'travel-and-expenses',
                scope: 'affidavit-signature',
                error,
              });
            }}
            className="MissingInvoiceSignature"
          />
        )}
      </div>
    </Modal>
  );
};
